import script from "./Pay.vue?vue&type=script&setup=true&lang=js"
export * from "./Pay.vue?vue&type=script&setup=true&lang=js"

import "@/styles/pay.css?vue&type=style&index=0&id=62b32f1f&lang=css&scoped=true&external"
import "./Pay.vue?vue&type=style&index=1&id=62b32f1f&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62b32f1f"]])

export default __exports__